import { createClient } from "@supabase/supabase-js";
import { env } from "./env";

/**
 * One client for the whole app. Customers never sign in (anon key + booking
 * token); only owners have a session. The session lives in localStorage under a
 * fixed key and is removed on logout together with the in-memory query cache.
 */
export const SESSION_STORAGE_KEY = "studio-owner-auth";

export const supabase = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
  auth: {
    storageKey: SESSION_STORAGE_KEY,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Implicit, not PKCE: an owner often requests the e-mail on one device and
    // opens it on another (or in a mail app's browser), where a PKCE verifier
    // does not exist. Operator invites (inviteUserByEmail) are implicit links too.
    flowType: "implicit",
  },
});
